import BetHistoryApi from './BetHistoryApi';
export default BetHistoryApi;
